import { render, staticRenderFns } from "./VProjectForm.vue?vue&type=template&id=2ddf738f&"
import script from "./VProjectForm.vue?vue&type=script&lang=js&"
export * from "./VProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports